/** v2.10 P4/P5: a touch screen (coarse pointer) — Enter is a new line there, and hotkeys are hidden. */
export function isTouch(): boolean {
  return typeof window !== "undefined" && !!window.matchMedia?.("(pointer: coarse)").matches;
}
